import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { AlertTriangle, Send } from "lucide-react";

/**
 * Branded confirmation modal — replaces native window.confirm().
 * Controlled via `open` + `onOpenChange`. Fires `onConfirm` on accept.
 */
export function ConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  title = "Are you sure?",
  description = "",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
}) {
  const Icon = destructive ? AlertTriangle : Send;
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        data-testid="confirm-dialog"
        className="border border-white/10 bg-[#121212] text-white rounded-none max-w-md p-0 overflow-hidden gap-0"
      >
        <div className="p-7">
          <AlertDialogHeader>
            <div className="flex items-center gap-3 mb-1">
              <span
                className={`grid place-items-center w-9 h-9 border ${
                  destructive ? "border-red-400/40 text-red-400" : "border-gold/40 text-gold"
                }`}
              >
                <Icon className="w-4 h-4" />
              </span>
              <AlertDialogTitle className="font-display uppercase text-xl tracking-tight text-white">
                {title}
              </AlertDialogTitle>
            </div>
            <AlertDialogDescription className="text-white/55 text-sm leading-relaxed pt-1">
              {description}
            </AlertDialogDescription>
          </AlertDialogHeader>
        </div>
        <AlertDialogFooter className="border-t border-white/10 p-4 bg-black/20">
          <AlertDialogCancel
            data-testid="confirm-dialog-cancel"
            className="rounded-none border-white/20 bg-transparent text-white/70 hover:bg-white/5 hover:text-white uppercase tracking-[0.12em] text-xs"
          >
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-dialog-confirm"
            onClick={onConfirm}
            className={`rounded-none uppercase tracking-[0.12em] text-xs font-semibold ${
              destructive
                ? "bg-red-500 text-white hover:bg-red-600"
                : "bg-gold text-white hover:bg-[#b00000]"
            }`}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
